import { Divider } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../../common/mixin';
export class MenuSeparatorComponent extends ChameleonElementMixin(Divider) {
}
